module.exports = __webpack_public_path__ + "static/media/truck_green.12f7f614.png";